import { http } from "./http";

export async function envioManualInvitacion(invitadoId: number) {
  return http.request<void>(`/api/admin/whatsapp/envio-manual/${invitadoId}`, {
    method: "POST",
  });
}

export async function envioInvitacionesEvento(eventoId: number) {
  return http.request<void>(`/api/admin/whatsapp/envio-invitaciones/${eventoId}`, {
    method: "POST",
  });
}
